
  // VUE_APP_BASEURL : '"http://dakaapi.cardhobby.cn"', 测试
  //VUE_APP_BASEURL : '"http://api.daka-culture.com"', 正式
const baseinfo = process.env.VUE_APP_BASEURL
const cms=process.env.VUE_APP_CMS
const gateway=process.env.VUE_APP_GATEWAY
const userinfo = gateway+'/user'

const Interface = {

  //下载   
  downloadWord:baseinfo+'/api/Common/WordDownloader/download-word',
  //Category
  GetCategoriesV1:baseinfo+'/api/Category/GetCategoriesV1',//get 获取所有类目属性层级结构(包含三级全部)
  GetOnlyCategories:baseinfo+'/api/Category/GetOnlyCategories',//get 获取所有类目（只含类目）
  GetOnlyPointsCategories:baseinfo+'/api/Category/GetOnlyPointsCategories',//get 获取积分所有类目

  //Commodity
  GetHotCommodityPageList:baseinfo+'/api/Commodity/GetHotCommodityPageList',//get 获取热门商品
  GetCommodityPageList:baseinfo+'/api/Commodity/GetCommodityPageList',//get 商品分页查询
  GetCommodities:baseinfo+'/api/Commodity/GetCommodities',//get 商品搜索
  GetPointsCommodities:baseinfo+'/api/Commodity/GetPointsCommodities',//get 积分商品搜索
  GetCommodityById:baseinfo+'/api/Commodity/GetCommodityById',//get 商品明细
  

  //Property
  GetKeyValueByFirstCategoryId:baseinfo+'/api/Property/GetKeyValueByFirstCategoryId',//get 根据一级类目id获取属性以及对应的key-value
  
  //Member
  SendMobileCode:baseinfo+'/api/Member/SendMobileCode',//post 发送验证码
  Register:baseinfo+'/api/Member/Register',//post 注册
  SignIn:baseinfo+'/api/Member/SignIn',//post 登录
  GetMemberInfoById:baseinfo+'/api/Member/GetMemberInfoById',//get 通过用户id获取用户详情
  ResetPassword:baseinfo+'/api/Member/ResetPassword',//post 验证码重置密码
  UpdateNickName:baseinfo+'/api/Member/UpdateNickName',//get 修改昵称
  SignResetPassword:baseinfo+'/api/Member/SignResetPassword',//post 登陆后验证码重置密码
  GetNationList:baseinfo+'/api/NationIconCode/GetNationIconAll',//get 获取国家图标接口
  //GetNationList:baseinfo+'/api/NationIconCode/GetNationIconCodePageList',//get 获取国家图标接口
  
  GetAreas: userinfo + "/api/Area/GetAreasByCode", //获取所有区域

  //MyCart
  GetMyCartPageList:baseinfo+'/api/MyCart/GetMyCartPageList',//get 获取购物车列表
  AddMyCart:baseinfo+'/api/MyCart/AddMyCart',//post 添加购物车
  DeleteMyCart:baseinfo+'/api/MyCart/DeleteMyCart',//post 删除购物车
  DeleteMyCartAll:baseinfo+'/api/MyCart/DeleteMyCartAll',//post 移除购物车全部商品

  //order
  GetOrdersPageListByMemberId:baseinfo+'/api/Order/GetOrdersPageListByMemberId',//get 通过用户id获取订单
  GetOrderById:baseinfo+'/api/Order/GetOrderById',//get 通过订单id获取详情
  GetOrderCountByStatus:baseinfo+'/api/Order/GetOrderCountByStatus',//get 通过用户id查询该用户订单总数
  CreateOrder:baseinfo+'/api/Order/CreateOrder',//post 创建订单
  ModifyOrderAdress:baseinfo+'/api/Order/ModifyOrderAdress',//post 修改订单地址
  OrderPay:baseinfo+'/api/Order/OrderPay',//post 付款更新状态
  SaveExpressInfo:baseinfo+'/api/Order/SaveExpressInfo',//post 保存快递信息
  CloseOrder:baseinfo+'/api/Order/CloseOrder',//post 关闭交易
  CompleteOrder:baseinfo+'/api/Order/CompleteOrder',//post 订单完成交易
  MemberCompleteOrder:baseinfo+'/api/Order/MemberCompleteOrder',//post 用户确认收货
  GetOrderTransferById:baseinfo+'/api/Order/GetOrderTransferById',//get 查看订单支付凭证

  //ShippingAddress
  SearchShippingAddresses:baseinfo+'/api/ShippingAddress/SearchShippingAddresses',//get 分页获取收货地址
  GetShippingAddressById:baseinfo+'/api/ShippingAddress/GetShippingAddressById',//get 根据Id获取收货地址
  GetShippingAddress:baseinfo+'/api/ShippingAddress/GetShippingAddress',//get 根据用户Id获取默认地址
  SaveAddress:baseinfo+'/api/ShippingAddress/Save',//post 保存收货地址
  UpdateAddress:baseinfo+'/api/ShippingAddress/Update',//post 更新收货地址
  DeleteAddress:baseinfo+'/api/ShippingAddress/Delete',//post 删除收货地址
  SetDefaultAddress:baseinfo+'/api/ShippingAddress/SetDefault',//post 设置默认收货地址

  //Realtime
  Realtime:baseinfo+'/api/Realtime/Search',//get 咨询分页查询

  //Advertisement
  Advertisement:baseinfo+'/api/Advertisement/Search',//get 广告位查询

  //Unionpay 
  Unionpay:baseinfo+'/api/Unionpay/Pay',//post 获取二维码
  UnionpayNotify:baseinfo+'/api/Unionpay/Notify',//post 通知处理接口
  SendMessage:baseinfo+'/api/Unionpay/SendMessage',//get 长连接
  SubmitPayVoucher:baseinfo+'/api/Order/SubmitPayVoucher',//POST 其他转账方式
  UploadImage: baseinfo + "/api/Common/UploadImage", //POST 上传图片

  //point
  PointsVerifyCode: baseinfo + "/api/Points/VerifyCode", //POST 卡片积分兑换
  GetIntegralDetails:baseinfo+'/api/Points/GetIntegralDetails',//get 通过用户id获取积分记录

  //ExchangeOrder
  CreateExchangeOrder: baseinfo + "/api/ExchangeOrder/CreateOrder", //get 兑换交换卡
  GetExchangeOrdersPageList:baseinfo+'/api/ExchangeOrder/GetOrdersPageListByMemberId',//get 通过用户id获取交换卡订单
  GetExchangeCommodityByCode:baseinfo+'/api/ExchangeOrder/GetExchangeCommodityByCode',//post 交换码查询交换卡


  //CMS
  GetChinaAreas:cms+'/api/City/GetChinaAreas',//get 地址列表
  


}
export default {
  Interface
};



// WEBPACK FOOTER //
// ./src/api/apiInterface.js